import {
  WSPill,
  WSButton,
  WSCentered,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSLayout,
  WSScreen,
  WSSwitchInput,
  WSText,
  useIsMobile,
  useModalOldContext
} from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { LogoApp } from "../../shared/components/LogoApp";
import { MembershipPackageCards } from "../components/MembershipPackages/MembershipPackageCards";
import {
  MONEY_GUARANTEE_MODAL,
  MoneyGuaranteeModal
} from "../components/MembershipPackages/MoneyGuaranteeModal";
import { SUBSCRIPTION_PACKAGES_ADDONS } from "../components/MembershipPackages/subscriptionPackages";
import styles from "./MembershipPlansWithAddOns.module.scss";

export const MembershipPlansWithAddOns: React.FC = () => {
  const history = useHistory();
  const isMobile = useIsMobile();
  const { openModal } = useModalOldContext();
  const [isAnnualBilling, setIsAnnualBilling] = useState(true);
  const onTogglePaymentFrequency = (value: any) => {
    setIsAnnualBilling(value);
  };

  return (
    <WSLayout line headerCenter={<LogoApp />} onBack={() => history.goBack()}>
      <MoneyGuaranteeModal />
      <WSElement>
        <WSElement py="2XL">
          <WSCentered>
            <WSFlexBox.Center direction="column">
              <WSText.Heading1 mx="XL" mb="XL">
                {isMobile
                  ? "Choose your membership"
                  : "Which Wingspan membership is right for you?"}
              </WSText.Heading1>
              <WSFlexBox.Center mb="XL">
                <WSText mr="M" color={isAnnualBilling ? "gray500" : "gray700"}>
                  Monthly billing
                </WSText>
                <WSSwitchInput
                  name="paymentFrequency"
                  value={isAnnualBilling}
                  onChange={onTogglePaymentFrequency}
                  className={styles.toggle}
                />
                <WSText ml="M" color={isAnnualBilling ? "gray700" : "gray500"}>
                  Annual billing
                </WSText>
              </WSFlexBox.Center>
              <WSFlexBox.Center mb="3XL">
                <WSText.ParagraphSm mr="XS" inline color="gray500">
                  Get
                </WSText.ParagraphSm>
                <WSPill theme="blue" text="2 months free" />
                <WSText.ParagraphSm ml="XS" inline color="gray500">
                  every year with annual billing.
                </WSText.ParagraphSm>
              </WSFlexBox.Center>

              <MembershipPackageCards
                mb="3XL"
                isAnnualBilling={isAnnualBilling}
                packages={SUBSCRIPTION_PACKAGES_ADDONS.filter(p => !p.isAddOn)}
              />
              <WSText.Heading1 mb="XS">Add-ons</WSText.Heading1>
              <WSText mb="XL" color="gray500" mx="M" align="center">
                Customize your membership with additional services
              </WSText>

              <MembershipPackageCards
                mb="3XL"
                isAnnualBilling={isAnnualBilling}
                packages={SUBSCRIPTION_PACKAGES_ADDONS.filter(p => p.isAddOn)}
              />

              <WSScreen.TabletAndDesktop>
                <WSFlexBox.Center p="M" className={styles.satisfactionMsg}>
                  <WSFlexBox.Center
                    p="XS"
                    mr="M"
                    className={styles.badgeIconContainer}
                  >
                    <WSIcon block name="reward" size="M" color="blue400" />
                  </WSFlexBox.Center>
                  <WSText color="gray700" mr="XS">
                    <b>100% satisfaction guaranteed.</b>
                  </WSText>
                  <WSText inline color="gray600" mr="XS">
                    Wingspan backs our product with a{" "}
                    <WSButton.Link
                      onClick={() => openModal(MONEY_GUARANTEE_MODAL)}
                    >
                      risk-free, money back guarantee.
                    </WSButton.Link>
                  </WSText>
                </WSFlexBox.Center>
              </WSScreen.TabletAndDesktop>
              <WSScreen.Mobile>
                <WSFlexBox.Center
                  alignItems="flex-start"
                  direction="column"
                  p="M"
                  className={styles.satisfactionMsg}
                >
                  <WSFlexBox.CenterY mb="M">
                    <WSFlexBox.Center
                      p="S"
                      mr="M"
                      className={styles.badgeIconContainer}
                    >
                      <WSIcon block name="reward" size="M" color="blue400" />
                    </WSFlexBox.Center>
                    <WSText color="gray700" mb="XS">
                      <b>100% satisfaction guaranteed</b>
                    </WSText>
                  </WSFlexBox.CenterY>
                  <WSText inline color="gray600">
                    Wingspan backs our product with a{" "}
                    <WSButton.Link
                      onClick={() => openModal(MONEY_GUARANTEE_MODAL)}
                    >
                      risk-free, money back guarantee.
                    </WSButton.Link>
                  </WSText>
                </WSFlexBox.Center>
              </WSScreen.Mobile>
            </WSFlexBox.Center>
          </WSCentered>
        </WSElement>
      </WSElement>
    </WSLayout>
  );
};
